"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setRef = _interopRequireDefault(require("@mui/utils/setRef"));
var _default = exports.default = _setRef.default;